// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"256":"8150bc51","327":"00e40129","541":"9764d9bb"}[chunkId] + ".css";
};